import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sizes } from '../config'
import { removeEmptyElements } from '../../helpers'

import Pagination from './Pagination'
import { useEffect } from 'preact/hooks'

const parseInteger = (value) =>
	value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0

export default () => {
	const { query, response } = useAppState()
	const { updateSearch } = useActions()

	const from = parseInteger(query.products?.from)
	const size = parseInteger(response.products.size)
	const total = parseInteger(response.products.total)
	const to = from + size

    // useEffect(() => {
    //     if(size > defaultConfig.serpSize) { // adds `?page=` only for pages 2 and beyond
    //         const currentUrlParams = new URLSearchParams(window.location.search);
    //         const page = Math.ceil((size / defaultConfig.serpSize));
    //         currentUrlParams.set('page', page);
    //         const updatedUrl = `${window.location.pathname}?${currentUrlParams.toString()}`;
    //         window.history.replaceState({}, '', updatedUrl);
    //     }
    // }, [ size ]);

    const updateHeadLinks = () => {
        // const currentPage = Math.ceil(size / parseInteger(defaultConfig.serpSize))
    
        const baseUrl = `${window.location.origin}${window.location.pathname}`
    
        const urlParams = new URLSearchParams(window.location.search)

        const currentPage = parseInteger(urlParams.get('page') ?? Math.ceil(size / parseInteger(defaultConfig.serpSize)))

        urlParams.delete('page')
    
        // const nextPageUrl = `${baseUrl}?${urlParams.toString()}&page=${currentPage + 1}`
        // const prevPageUrl = currentPage === 2 
        //     ? `${baseUrl}?${urlParams.toString()}`
        //     : `${baseUrl}?${urlParams.toString()}&page=${currentPage - 1}`

        const nextPageUrl = new URL(baseUrl)
        nextPageUrl.searchParams.append('page', currentPage + 1)
        
        const prevPageUrl = new URL(baseUrl)
        
        if (currentPage !== 2) {
            prevPageUrl.searchParams.append('page', currentPage - 1)
        }

        for (const [key, value] of urlParams) {
            nextPageUrl.searchParams.append(key, value)
            prevPageUrl.searchParams.append(key, value)
        }

        document.querySelectorAll('link[rel="prev"], link[rel="next"]').forEach(link => link.remove())

        if (currentPage > 1) {
            const prevLink = document.createElement('link')
            
            prevLink.rel = 'prev'
            prevLink.href = prevPageUrl
            document.head.appendChild(prevLink)
        }

        if (to < total) {
            const nextLink = document.createElement('link')

            nextLink.rel = 'next'
            nextLink.href = nextPageUrl
            document.head.appendChild(nextLink)
        }
    }

    updateHeadLinks()

	const loadMore = () => {
		updateSearch({
			products: {
                from: from,
				size: parseInteger(query.products.size) + parseInteger(defaultConfig.serpSize)
			}
		})
		removeEmptyElements()
		//okeWidgetApi.initAllWidgets()
	};

	return (
		<div class="ns-my-4 ns-mx-0" style="text-align: center;">
			{/* <Pagination /> */}
			{to < total &&
				<a class="button button--primary main-banner__button ns-load-more" tabindex="0" onClick={loadMore}>
                    <span class="visually-hidden">Load More Products</span>
                    <span aria-hidden="true">Load More</span>
                </a>
			}
		</div>
	)
}
